import { render, staticRenderFns } from "./dashboard-sales-chart.vue?vue&type=template&id=7ec83cc4&"
import script from "./dashboard-sales-chart.vue?vue&type=script&lang=js&"
export * from "./dashboard-sales-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports